/**
 * 【菜单列表】
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XOKButton, XCancelButton, XTabNav, XInput, XSelect } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { Row, Col, Divider, Menu, message, Modal, Table } from 'antd';
import { connect } from 'react-redux';
import model from '@/reducers/permissions/assignauthority/model';
import { getLocalStorage } from '@/assets/js/storage';
import AddRole from './modal/AddRole';
import DeleteModal from './modal/DeleteModal';
import EditRole from './modal/EditRole';
import AddStaff from './modal/AddStaff';
import EditStaff from './modal/EditStaff';
import BtnSet from './modal/BtnSet';
import { PlusCircleOutlined, MinusCircleOutlined, FormOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import http from '@/assets/api/http';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import RolesPermission from './RolesPermission';

const { confirm } = Modal;

class Main extends React.Component {
    state = {
        tab: [
            { id: 1, label: '员工角色分配' },
            { id: 2, label: '角色权限设置' },
        ],
        roleId: '', // 角色ID（角色权限配置用）
        roleName: '', // 角色名称（角色权限配置用）
        isReadWrite: 0, // 判断该角色类型是否可以设置权限 0不可设 1可设（角色权限配置用）
        isAdmin: 0, // 是否为管理员
        curTabID: 1,  // 当前显示的Tab页ID
        loginName: '', // 员工账号（搜索条件）
        emplName: '', // 员工姓名（搜索条件）
        dept: {}, // 所属部门（搜索条件）
        comp: {}, // 运营中心
        OpenModalType: '', // 当前打开的弹框
        openModeParam: {}, // 弹框传参
        emplTableType: 0,
        roleType: '',  // 角色类型： 总控，运营公司
    };
    emplTableType = 0; // 0:全部员工 1: 部门下员工  2：角色下员工  3：未分类员工  4:其它
    isEmplEdit = false;  // 该角色下的员工是否可编辑（系统默认的顶级角色不可编辑，新建的二级角色可以编辑）
    searchCache = {}; // 查询缓存
    defaultInit = true;

    dataSource = {}; // 角色权限设置数据源
    selectedRowKeys = []; // 当前选中的菜单项
    allMenusWithoutBtn = []; // 所有的菜单权限

    componentDidMount() {
        const userInfo = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : null;
        if (userInfo) {
            this.setState({ isAdmin: userInfo.isAdmin });
        }
        this.props.getlistRoles();
        this.props.getDeptPullDown({ isNeedSanji: 1, isNeePermissionFilter: 0 });
        this.props.getCompany({ pageNum: 1, pageSize: 1000000 });
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    // Tab页切换
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID });
    }

    // 表格操作
    _tableAction = (type, emplTableType, record) => {
        const _this = this;
        switch (type) {
            case 'del':
                confirm({
                    icon: <ExclamationCircleOutlined />,
                    content: '移除此员工，移除后失去当前角色权限是否继续？',
                    onOk() {
                        if (emplTableType == 1) {
                            http('/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.delEmplFromDept',
                                { id: record.id }, 'POST').then(() => {
                                    message.success('移除成功！');
                                    _this.props.getlistRoles();
                                    _this._searchHandle();
                                }).catch((e) => {
                                    message.error(e.message);
                                });
                        } else {
                            http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleEmplMisService.deleteRoleEmpl',
                                { emplId: record.id, id: _this.state.roleId }, 'POST').then(() => {
                                    message.success('移除成功！');
                                    _this.props.getlistRoles();
                                    _this._searchHandle();
                                }).catch((e) => {
                                    message.error(e.message);
                                });
                        }
                    },
                    onCancel() { },
                });
                break;
            case 'edit':
                this.setState({ OpenModalType: 'edit', openModeParam: { id: record.id, emplName: record.emplName } });
                break;
        }
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this._searchHandle();
    }

    // 角色菜单
    _renderRole = (role) => {
        const children = role.children || [];
        return <>
            <Menu.Item key={role.id} onClick={() => {
                this.isEmplEdit = false;
                this.emplTableType = 1;
                this.defaultInit = true;
                this.selectedRowKeys = [];
                this._cleanState();
                this.searchCache = { roleId: role.id, deptId: role.deptId };
                this.setState({emplTableType: 1, roleId: role.id, roleName: role.roleName, roleType: role.roleType, isReadWrite: role.isReadWrite }, () => {
                    if (this.state.isReadWrite == 1) {
                        // this.props.getListMenuByRole({ roleId: this.state.roleId });
                    }
                });
            }}><div className={styles.menuitem}><div className={styles.text}>{role.roleName}({role.emplCount})</div><div><PlusCircleOutlined style={{ marginLeft: '10px' }} onClick={() => this._addRoleHandle({ role })} /></div></div></Menu.Item>
            {
                children.map((item) => {
                    return <Menu.Item key={item.id} onClick={() => {
                        this.isEmplEdit = true;
                        this.defaultInit = true;
                        this.emplTableType = 2;
                        this.selectedRowKeys = [];
                        this.searchCache = { roleId: item.id, roleType: item.roleType, roleName: item.roleName };
                        this._cleanState();
                        this.setState({emplTableType: 2, roleId: item.id, roleName: item.roleName, roleType: item.roleType, isReadWrite: item.isReadWrite }, () => {
                            if (this.state.isReadWrite == 1) {
                                // this.props.getListMenuByRole({ roleId: this.state.roleId });
                            }
                        });
                    }}><div className={styles.childmenuitem}><div className={styles.text}>{item.roleName}({item.emplCount})</div><div><MinusCircleOutlined style={{ marginLeft: '10px' }} onClick={() => this._delRoleHandle(item)} /><FormOutlined onClick={() => this._editRoleHandle(item)} /></div></div></Menu.Item>;
                })
            }
        </>;
    }

    // 添加角色
    _addRoleHandle = (record = undefined) => {
        this.setState({ OpenModalType: 'addRole' });
        record && this.setState({ openModeParam: record });
    };

    // 删除角色
    _delRoleHandle = (record) => {
        this.setState({ OpenModalType: 'delRole', openModeParam: { id: record.id } });
    };

    // 编辑角色
    _editRoleHandle = (record) => {
        this.setState({ OpenModalType: 'editRole', openModeParam: record });
    };

    // 新建员工
    _newHandle = () => {
        this.setState({ OpenModalType: 'addStaff', openModeParam: { roleId: this.searchCache.roleId, roleName: this.searchCache.roleName } });
    }

    //打开弹窗
    _renderMode = () => {
        const { OpenModalType, openModeParam } = this.state;
        switch (OpenModalType) {
            case 'addRole':
                return <AddRole title='新建角色' closeMode={this._closeMode} data={openModeParam} />;
            case 'delRole':
                return <DeleteModal title='删除角色' closeMode={this._closeMode} data={openModeParam} />;
            case 'editRole':
                return <EditRole title='编辑角色' closeMode={this._closeMode} data={openModeParam} />;
            case 'addStaff':
                return <AddStaff title='添加员工' closeMode={this._closeMode} data={openModeParam} />;
            case 'edit':
                return <EditStaff title='编辑员工' closeMode={this._closeMode} data={openModeParam} />;
            case 'btnSet':
                return <BtnSet title={`${'设置“' + openModeParam.menuName + '”按钮权限'}`} closeMode={this._closeMode} data={openModeParam} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeMode = (update, type, data) => {
        this.setState({ OpenModalType: '', openModeParam: {} });
        if (type == 'btnset') {
            // 改变dataSource
            this.defaultInit = false;
            this.dataSource = this._resetDataSourceFromBtns(this.dataSource, data.id, data);
        }
        if (update) {
            this.props.getlistRoles(); // 获取角色列表
            this._searchHandle();
        }
    }

    // 改变dataSource按钮权限
    _resetDataSourceFromBtns = (list, id, data) => {
        return list.map((item) => {
            if (item.id == id) {
                item = { ...data, btns: this._deepCopy(data.btns) };
            } else {
                if (item.children && Array.isArray(item.children) && item.children.length > 0) {
                    item.children = this._resetDataSourceFromBtns(item.children, id, data);
                }
            }
            return item;
        });
    }

    // 查询员工
    _searchHandle = () => {
        const { loginName, emplName, dept, comp } = this.state;
        if (this.emplTableType == 0) {
            this.searchCache = {
                ...this.searchCache,
                loginName,
                emplName,
                deptId: dept.id,
            };
            this.props.getEmplList(this.searchCache);
        } else if (this.emplTableType == 1) {
            this.searchCache = {
                ...this.searchCache,
                loginName,
                emplName,
            };
            this.props.getEmplList(this.searchCache);
        } else if (this.emplTableType == 2) {
            this.searchCache = {
                ...this.searchCache,
                loginName,
                emplName,
            };
            this.props.getListEmplsByRole(this.searchCache);
        } else if (this.emplTableType == 3) {
            this.props.getListUnassortedEmpls({ ...this.searchCache, deptId: undefined });
        } else if (this.emplTableType == 4) {
            this.searchCache = {
                ...this.searchCache,
                loginName,
                emplName,
                companyId: comp.companyId
            };
            this.props.getListEmplsByRole(this.searchCache);
        }
    }

    // 重置员工
    _resetHandle = () => {
        this._cleanState();
    }

    // 清理状态
    _cleanState = () => {
        this.searchCache = {
            ...this.searchCache,
            pageSize: 10,
            pageNum: 1
        };
        this.setState({
            loginName: '', // 员工账号（搜索条件）
            emplName: '', // 员工姓名（搜索条件）
            dept: {}, // 所属部门（搜索条件）
            comp: {}, // 运营中心（搜索条件）
        }, () => {
            this._searchHandle();
        });
    }

    // 设置权限
    _updateMenuPower = () => {
        const { roleId } = this.state;
        let menuIds = [];
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
            for (let m = 0; m < this.allMenusWithoutBtn.length; m++) {
                if (this.selectedRowKeys[i] == this.allMenusWithoutBtn[m].menuId) {
                    menuIds.push({ menuId: this.allMenusWithoutBtn[m].menuId, readType: 'READ_WRITE' });
                    break;
                }
            }
        }
        this.btns = [];
        this._getBtns(this.dataSource);
        menuIds = menuIds.concat(this.btns);
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.saveRoleMenu', { roleId, menuIds }, 'POST').then(() => {
            message.success('设置成功！');
            this.defaultInit = true;
            // this.props.getListMenuByRole({ roleId: this.state.roleId });
            this._searchHandle();
        }).catch((e) => {
            message.error(e.message);
        });
    }

    // 获取按钮权限设置
    _getBtns = (listMune) => {
        listMune.forEach((item) => {
            if (item.menuType == 'BUTTON' && item.readType != '') {
                this.btns.push({ menuId: item.id, readType: item.readType });
            } else {
                if (item.btns && item.btns.length > 0) {
                    this._getBtns(item.btns);
                }
                if (item.children && item.children.length > 0) {
                    this._getBtns(item.children);
                }
            }
        });

        return listMune.filter((item) => {
            let boolean = false;
            if (item.menuType == 'BUTTON') {
                boolean = false;
            } else {
                boolean = true;
                this.allMenusWithoutBtn.push({ menuId: item.id, readType: item.readType, isChecked: item.isChecked });
                if (item.children && item.children.length > 0) {
                    item.btns = [];
                    for (let i = 0; i < item.children.length; i++) {
                        if (item.children[i].menuType == 'BUTTON') {
                            item.btns.push(item.children[i]);
                        }
                    }
                    item.children = this._filterWithoutButton(item.children);
                }
            }
            return boolean;
        });
    }

    // 渲染文本
    _renderTreeText = () => {
        if ((this.emplTableType == 1 || this.emplTableType == 2 || this.emplTableType == 4) && this.state.isReadWrite == 1) {
            return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p className={styles.smallHeader}>预设<span style={{ color: '#3094FB', fontWeight: 'bold' }}> {this.state.roleName} </span>拥有的菜单权限</p>
                    <XOKButton style={{ width: '80px', marginLeft: '20px' }} label='设置' onClick={this._updateMenuPower} />
                </div>
            );
        } else {
            return (
                <p className={styles.smallHeader}>无权限修改该角色的菜单权限</p>
            );
        }
    }

    // 权限表格列
    columns = [
        {
            title: '菜单名称',
            dataIndex: 'menuName',
            key: 'menuName',
            width: '80%',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '20%',
            render: (text, item) => {
                let hasBtn = false;
                if (item.btns && item.btns.length > 0) {
                    for (let i = 0; i < item.btns.length; i++) {
                        if (item.btns[i].menuType == 'BUTTON') {
                            hasBtn = true;
                            break;
                        }
                    }
                }

                return (
                    hasBtn ?
                        <div className={styles.action}>
                            <div className={styles.item} onClick={() => {
                                this.setState({ OpenModalType: 'btnSet', openModeParam: { ...item } });
                            }}>设置按钮权限</div>
                        </div> : null
                );
            }
        },
    ];

    // 权限表格选中
    rowSelection = {
        checkStrictly: true,
        onChange: (selectedRowKeys) => {
            this.defaultInit = false;
            this.selectedRowKeys = selectedRowKeys;
            this.setState({ update: Math.random() });
        },
    };

    // 渲染菜单权限表格
    _renderTreeTable = () => {
        if ((this.emplTableType == 1 || this.emplTableType == 2 || this.emplTableType == 4) && this.state.isReadWrite == 1) {
            const { listMune } = this.props;
            if (!listMune || listMune.length == 0) {
                return null;
            }

            if (this.defaultInit) {
                this.allMenusWithoutBtn = [];
                this.dataSource = this._filterWithoutButton(this._deepCopy(listMune));
                let defaultRowKeys = [];
                for (let i = 0; i < this.allMenusWithoutBtn.length; i++) {
                    if (this.allMenusWithoutBtn[i].isChecked == 1) {
                        defaultRowKeys.push(this.allMenusWithoutBtn[i].menuId);
                    }
                }
                this.selectedRowKeys = defaultRowKeys;
                this.rowSelection.selectedRowKeys = defaultRowKeys;
            }

            return <Table
                defaultExpandAllRows={true}
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={(record) => record.id}
                columns={this.columns}
                rowSelection={{ ...this.rowSelection }}
                dataSource={this.dataSource}
                pagination={false}
            />;
        } else {
            return null;
        }
    }

    // 数组对象类型深度拷贝算法
    _deepCopy(obj) {
        if (typeof obj !== 'object') {
            return obj;
        }
        var res = Array.isArray(obj) ? [] : {};
        for (let i in obj) {
            if (i == 'component') {
                res[i] = obj[i];
            } else {
                res[i] = this._deepCopy(obj[i]);
            }
        }
        return res;
    }

    // 过滤掉按钮类型的菜单
    _filterWithoutButton = (listMune) => {
        return listMune.filter((item) => {
            let boolean = false;
            if (item.menuType == 'BUTTON') {
                boolean = false;
            } else {
                boolean = true;
                this.allMenusWithoutBtn.push({ menuId: item.id, readType: item.readType, isChecked: item.isChecked });
                if (item.children && item.children.length > 0) {
                    item.btns = [];
                    for (let i = 0; i < item.children.length; i++) {
                        if (item.children[i].menuType == 'BUTTON') {
                            item.btns.push(item.children[i]);
                        }
                    }
                    item.children = this._filterWithoutButton(item.children);
                }
            }
            return boolean;
        });
    }

    render() {
        const { curTabID, isAdmin, loginName, emplName, dept, comp } = this.state;
        const { listRoles, deptPullDown, emplList, listEmplsByRole, listUnassortedEmpls, company } = this.props;
        let emplDataSource = []; // 员工表格
        if (this.emplTableType == 0) { // 全部员工 
            emplDataSource = emplList;
        } else if (this.emplTableType == 1) { // 部门员工
            emplDataSource = emplList;
        } else if (this.emplTableType == 2) { // 角色员工
            emplDataSource = listEmplsByRole;
        } else if (this.emplTableType == 3) { // 未分类员工
            emplDataSource = listUnassortedEmpls;
        } else if (this.emplTableType == 4) {
            emplDataSource = listEmplsByRole; // 其它角色员工
        }

        const { companyEmplCount, ownRole, unassortedResp, otherAdminRole } = listRoles;
        const companyList = company.dataList ? company.dataList : [];
        if (!this.defaultInit && Array.isArray(this.selectedRowKeys)) {
            this.rowSelection.selectedRowKeys = this.selectedRowKeys;
        }

        return (
            <div id='autoheight' className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                <div className={styles.tableContainer} style={{ height: '100%' }}>
                    <Row gutter={24} style={{ height: '100%' }}>
                        <Col span={6} style={{ padding: 0, borderRight: '1px solid #ccc' }}>
                            <XOKButton style={{ width: '100px' }} label='新建角色' onClick={() => this._addRoleHandle({})} />
                            <Menu mode="inline" style={{ width: '100%' }}>
                                {
                                    isAdmin == 1 ? <>
                                        <Divider style={{ margin: '10px 0px' }} />
                                        <Menu.Item onClick={() => {
                                            this.isEmplEdit = false;
                                            this.emplTableType = 0;
                                            this.setState({emplTableType: 0, roleType: 'PLAT'});
                                            this._cleanState();
                                            this.props.getEmplList();
                                        }}>{'全部员工'}({companyEmplCount})</Menu.Item>
                                    </> : null
                                }
                                <Divider style={{ margin: '10px 0px' }} />
                                {
                                    ownRole && ownRole.map((item) => {
                                        return this._renderRole(item);
                                    })
                                }
                                <Divider key={'UnassortedEmpls'} style={{ margin: '10px 0px' }} />
                                {
                                    <Menu.Item onClick={() => {
                                        this.isEmplEdit = false;
                                        this.emplTableType = 3;
                                        this.setState({emplTableType: 3, roleType: 'PLAT'});
                                        this._cleanState();
                                    }}>{unassortedResp && unassortedResp.roleName}({unassortedResp && unassortedResp.emplCount})</Menu.Item>
                                }
                                <Divider key={'otherAdminRole'} style={{ margin: '10px 0px' }} />
                                {
                                    otherAdminRole && otherAdminRole.map((item) => {
                                        return (<Menu.Item key={item.id} onClick={() => {
                                            this.defaultInit = true;
                                            this.isEmplEdit = false;
                                            this.emplTableType = 4;
                                            this.selectedRowKeys = [];
                                            this._cleanState();
                                            this.props.cleanListMenuByRole();
                                            this.searchCache = { roleId: item.id, roleType: item.roleType };
                                            this.props.getListEmplsByRole({ roleId: item.id, roleType: item.roleType });
                                            this.setState({emplTableType: 4, roleId: item.id, roleName: item.roleName, roleType: item.roleType, isReadWrite: item.isReadWrite }, () => {
                                                if (this.state.isReadWrite == 1) {
                                                    // this.props.getListMenuByRole({ roleId: this.state.roleId });
                                                }
                                            });
                                        }}>{item && item.roleName}({item.emplCount})</Menu.Item>);
                                    })
                                }
                            </Menu>
                        </Col>
                        <Col span={18} style={{ height: '100%', paddingLeft: 12 }}>
                            {curTabID === 1 &&
                                <div>
                                    <div className={styles.row1}>
                                        <XInput
                                            label='员工账号'
                                            placeholder='请输入'
                                            value={loginName}
                                            bindThis={this}
                                            bindName='loginName'
                                        />
                                        <XInput
                                            label='员工姓名'
                                            placeholder='请输入'
                                            value={emplName}
                                            bindThis={this}
                                            bindName='emplName'
                                        />
                                        {
                                            this.emplTableType == 0 || this.emplTableType == 3 ? <XSelect
                                                label='所属部门'
                                                placeholder='请选择'
                                                renderData={deptPullDown}
                                                dataIndex='deptName'
                                                keyIndex='id'
                                                value={dept.deptName}
                                                bindThis={this}
                                                bindName='dept'
                                                showSearch={true}
                                            /> : null
                                        }
                                        {
                                            this.emplTableType == 4 ? <XSelect
                                                label='运营公司'
                                                placeholder='请选择'
                                                renderData={companyList}
                                                dataIndex='companyName'
                                                keyIndex='companyId'
                                                value={comp.companyName}
                                                bindThis={this}
                                                bindName='comp'
                                                showSearch={true}
                                            /> : null
                                        }
                                        <XOKButton
                                            label='查询'
                                            onClick={this._searchHandle}
                                        />
                                        <XCancelButton
                                            label='重置'
                                            onClick={this._resetHandle}
                                        />
                                    </div>
                                    <div className={styles.row2} style={!this.isEmplEdit ? { display: 'none' } : { display: 'block' }}>
                                        <XOKButton
                                            style={{ width: '100px' }}
                                            label='添加员工'
                                            onClick={this._newHandle}
                                        />
                                    </div>
                                    <TableContent
                                        curTabID={this.state.curTabID}
                                        renderData={emplDataSource}
                                        tableAction={this._tableAction}
                                        paginationChange={this._paginationChange}
                                        emplTableType={this.emplTableType}
                                    />
                                </div>
                            }
                            {
                                curTabID === 2 &&
                                <div>
                                    {/* {this._renderTreeText()} */}
                                    {/* <Divider /> */}
                                    {/* {this._renderTreeTable()} */}
                                    <RolesPermission {...this.state} />
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
                {this._renderMode()}
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    getlistRoles: PropTypes.func, // 获取权限列表
    listRoles: PropTypes.object, // 权限列表
    getDeptPullDown: PropTypes.func, // 获取部门下拉列
    deptPullDown: PropTypes.array, // 部门下拉列
    getEmplList: PropTypes.func, // 获取员工列表(全部、部门)
    emplList: PropTypes.object, // 员工列表
    getListEmplsByRole: PropTypes.func, // 获取员工列表(角色)
    listEmplsByRole: PropTypes.object, // 员工列表
    getListUnassortedEmpls: PropTypes.func, // 获取员工列表(未分类)
    listUnassortedEmpls: PropTypes.object, // 员工列表
    getCompany: PropTypes.func,
    company: PropTypes.object,
    getListMenuByRole: PropTypes.func,
    listMune: PropTypes.array,
    cleanListMenuByRole: PropTypes.func,
    setBreadcrumbPaths: PropTypes.func,
    match: PropTypes.object, // router match
};

const mapStateToProps = (state) => ({
    listRoles: state.assignauthority.getlistRoles,
    deptPullDown: state.assignauthority.getDeptPullDown,
    emplList: state.assignauthority.getEmplList,
    listEmplsByRole: state.assignauthority.getListEmplsByRole,
    listUnassortedEmpls: state.assignauthority.getListUnassortedEmpls,
    company: state.assignauthority.getCompany,
    listMune: state.assignauthority.getListMenuByRole,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);